import Vue from 'vue'
import Glide from '@glidejs/glide'
Vue.prototype.$eventHub = new Vue();

if (document.getElementById('vue-header')) {
  new Vue({
    el: '#vue-header',
    data() {
      return {
        isMenuOpen: false,
        ww: window.innerWidth
      }
    },
    mounted() {
      window.addEventListener('scroll', (e) => {
        this.scrollPos = window.scrollY;
      });
      window.addEventListener('resize', (e) => {
        this.ww = window.innerWidth;
      });
    },
    methods: {
      toggleMenu() {
        this.isMenuOpen = !this.isMenuOpen;
        document.body.style.overflow = (this.isMenuOpen)? 'hidden' : 'scroll'
      },
      initCarouselModal() {
        new Glide('.js-glide-realisation-modal', {
          animationDuration: 1000,
          animationTimingFunc: 'ease',
          perView: 1,
          peek: 340,
          type: "carousel"
        }).mount()
      }
    }
  })
}